const DEFAULT_LOCALE = "en";

// Mirrors Languages::RIGHT_TO_LEFT in common/models/Languages.php
const RTL_LOCALES = new Set(['ar', 'ārc', 'az', 'iw', 'ku', 'dv', 'fa', 'ur']);

export const isRTL = (locale: string): boolean => RTL_LOCALES.has(locale);

export const getCurrentLocale = (): string => {
  if (typeof document === 'undefined') {
    return DEFAULT_LOCALE;
  }
  const htmlElement = document.querySelector("html");
  const langAttributeValue = htmlElement?.getAttribute("lang");

  return langAttributeValue ? langAttributeValue.substring(0, 2) : DEFAULT_LOCALE;
};

export const isDefaultLocale = (locale: string): boolean => {
  return locale === DEFAULT_LOCALE;
};

export {
  DEFAULT_LOCALE
};
